export default __webpack_public_path__ + "static/media/icon-steps.3ed249da.png";